export default "__VITE_ASSET__DhRHFrup__"